module.exports = __webpack_public_path__ + "static/media/dextools.82a6f725.png";